// ***************************************
// tgfDialogs.DialogLobby
//
// A template for new dialogs
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 23-9-2015
// ***************************************
import { ComponentContainer } from "../components/ComponentContainer";
import { tgfComponents } from "../components/tgfComponents";
import { tgfGraphics } from "../tgfGraphics";
import { tgfSettings } from "../tgfSettings";
import { DialogBase } from "./DialogBase";
import { tgfDialogs } from "./tgfDialogs";
// Directives for jslint
/*global tgfSettings, tgfDialogs, tgfComponents */
tgfSettings.dialogDefaults.dialogLobby = {
    backgroundImage: null,
    listSpacing: 28,
    listOffset: [
        {
            x: 0,
            y: 0
        },
        {
            x: 0,
            y: 0
        },
        {
            x: 0,
            y: 0
        }
    ],
    paddingTop: 0,
    paddingBottom: 0,
    componentLobbyListClass: tgfComponents.ComponentLobbyList,
    componentLobbyListItemClass: tgfComponents.ComponentLobbyListItem,
    headings: {
        active: 'YOUR TURN',
        inactive: 'THEIR TURN',
        done: 'FINISHED MATCHES',
    },
    components: [] // The additional components to add
};
// The constructor for the dialog
/**
 * @constructor
 * @base DialogBase
 */
tgfDialogs.DialogLobby = function (properties) {
    "use strict";
    this.name = "DialogLobby"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.dialogLobby);
    // add base settings
    if (tgfSettings.lobbyScreenDialogProperties) {
        this.setProperties(tgfSettings.lobbyScreenDialogProperties);
    }
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    // console.log(this.paddingTop, this.paddingBottom);
};
export var DialogLobby = tgfDialogs.DialogLobby;
// Inherit the base dialog
tgfDialogs.inherit(tgfDialogs.DialogLobby, DialogBase);
// ***************************************
// Specific methods for this dialog
// ***************************************
// ***************************************
// Internal methods
// ***************************************
// ***************************************
// Preparing and showing
//      - These can be removed if no processing is required
// ***************************************
// Processing required when preparing the dialog for use
tgfDialogs.DialogLobby.prototype.doPrepare = function () {
    "use strict";
    var i;
    this._getInitialData();
    if (this.backgroundImage) {
        this._backgroundImage = this.backgroundImage.clone();
        this.baseContainer.addChild(this._backgroundImage);
    }
    // list active games
    var posY = this.paddingTop + this.listOffset[0].y;
    var listHeight;
    this._listActive = new this.componentLobbyListClass({
        type: 'active',
        x: this.listOffset[0].x,
        y: posY,
        items: this._data.active,
        componentItemClass: this.componentLobbyListItemClass,
        headingText: this.headings.active
    });
    // list inactive games
    listHeight = this._listActive.getHeight();
    posY = this._listActive.y + listHeight + this.listSpacing + this.listOffset[1].y;
    this._listInactive = new this.componentLobbyListClass({
        type: 'inactive',
        x: this.listOffset[1].x,
        y: posY,
        items: this._data.inactive,
        componentItemClass: this.componentLobbyListItemClass,
        headingText: this.headings.inactive
    });
    // list completed/done games
    listHeight = this._listInactive.getHeight();
    posY = this._listInactive.y + listHeight + this.listSpacing + this.listOffset[2].y;
    this._listDone = new this.componentLobbyListClass({
        type: 'done',
        x: this.listOffset[2].x,
        y: posY,
        items: this._data.done,
        componentItemClass: this.componentLobbyListItemClass,
        headingText: this.headings.done
    });
    // container
    this._listContainer = new ComponentContainer({ x: -tgfGraphics.areaWidth / 2, y: -tgfGraphics.areaHeight / 2 });
    this._listContainer.components.push(this._listActive);
    this._listContainer.components.push(this._listInactive);
    this._listContainer.components.push(this._listDone);
    var areaHeight = this._listActive.y + this._listActive.getHeight() + this._listInactive.getHeight() + this._listDone.getHeight() + (2 * this.listSpacing) + this.paddingBottom + this.listOffset[0].y + this.listOffset[1].y + this.listOffset[2].y;
    // scroll
    var scrollProps = {};
    scrollProps.x = tgfGraphics.areaWidth / 2,
        scrollProps.y = tgfGraphics.areaHeight / 2,
        scrollProps.scrollHorizontal = false; // Whether to allow horizontal scrolling
    scrollProps.scrollVertical = true; // Whether to allow vertical scrolling
    scrollProps.width = tgfGraphics.areaWidth;
    scrollProps.height = tgfGraphics.areaHeight; // The height of the area in the box
    scrollProps.areaWidth = tgfGraphics.areaWidth; // The width of the area in the box
    scrollProps.areaHeight = areaHeight; // The height of the area in the box
    scrollProps.clip = true; // Whether to clip the subcomponents
    scrollProps.showHorizontalScrollBar = false; // Whether to show the horizontal scroll bar when required
    scrollProps.showVerticalScrollBar = false; // Whether to show the vertical scroll bar when required
    scrollProps.cancelEvents = false;
    this._scrollBox = new tgfComponents.ScrollBox(scrollProps);
    this._scrollBox.components.push(this._listContainer);
    this.components.push(this._scrollBox);
    this.doPrepareCustom();
    // Add the additional components
    if (this.components) {
        for (i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    }
};
tgfDialogs.DialogLobby.prototype._getInitialData = function () {
    // overwrite me
    if (!this._data) {
        // dummy data
        this._data = {};
        this._data.active = [];
        this._data.inactive = [];
        this._data.done = [];
    }
};
tgfDialogs.DialogLobby.prototype._onGetLobbyData = function (data) {
    this._data = data;
    this._populateLobby();
};
tgfDialogs.DialogLobby.prototype._populateLobby = function () {
    console.log('populate');
};
// Processing required when freeing the dialog from use
tgfDialogs.DialogLobby.prototype.doPrepareCustom = function () {
    // override me
}; // Processing required when freeing the dialog from use
tgfDialogs.DialogLobby.prototype.doPrepareAfterComponentsAdded = function () {
    // override me
};
tgfDialogs.DialogLobby.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    tgfDialogs.DialogLobby.uber.handleBeginStep.call(this, timePassed);
    this._scroll = this._scrollBox.getScroll();
    if (this._afterBeginStep)
        this._afterBeginStep(timePassed);
};
tgfDialogs.DialogLobby.prototype.handleEndStep = function (timePassed) {
    "use strict";
    tgfDialogs.DialogLobby.uber.handleEndStep.call(this, timePassed);
    this._scroll = this._scrollBox.getScroll();
    if (this._afterEndStep)
        this._afterEndStep(timePassed);
};
tgfDialogs.DialogLobby.prototype.handleSpecial = function (id, args) {
    switch (id) {
        case 'room-select': {
            this.onRoomSelected(args);
            break;
        }
        case 'room-create': {
            this.onRoomCreate();
            break;
        }
    }
    tgfDialogs.DialogLobby.uber.handleSpecial.call(this, id, args);
};
tgfDialogs.DialogLobby.prototype.onRoomSelected = function (args) {
    console.log('onRoomSelected', args);
    this.free();
};
tgfDialogs.DialogLobby.prototype.onRoomCreate = function () {
    console.log('onRoomCreated');
    this.free();
};
